import { Select, SelectProps as AntdSelectProps } from 'antd';

import { Antd3FormElementProps } from './Antd3Form';

export const Antd3Select = ({
    form,
    id,
    required = false,
    getFieldDecoratorOptions,
    ...inputProps
}: AntdSelectProps & Antd3FormElementProps) => (
    <>
        {form?.getFieldDecorator ? (
            form.getFieldDecorator(id, getFieldDecoratorOptions)(<Select {...inputProps} />)
        ) : (
            <Select {...inputProps} />
        )}
    </>
);
